<div class="app-content notifications">
    <button slb-button (click)="sayHello('toast')" title='toast'>Say Hello</button>
    <button slb-secondary-button (click)="sayHello('modal')" title='modal'>Say Hello</button>
    <button slb-tertiary-button (click)="sayHello('banner')" title='banner'>Say Hello</button>
</div>